import React from 'react';
import './css/style.css';
import './css/common.css';
// import './css/layout.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { useSelector } from 'react-redux';

// 職員用ログイン
import Login from './containers/login/Login';

// ここから予約
import BaseFrame from './containers/reserve/BaseFrame';
import SelectDate from './containers/reserve/SelectDate';
import SelectTime from './containers/reserve/SelectTime';
import SelectBusiness from './containers/reserve/SelectBusiness';
import SelectPlace from './containers/reserve/SelectPlace';
// import InputUserInfo from './containers/reserve/InputUserInfo';
import CustomizeReserveForm from './containers/reserve/CustomizeReserveForm';
// import Confirmation from './containers/reserve/Confirmation';
import CustomizeConfirmation from './containers/reserve/CustomizeConfirmation';
import Top from './containers/reserve/Top';
// import Complete from './containers/reserve/Complete';
import CustomizeComplete from './containers/reserve/CustomizeComplete';

// 予約変更・キャンセル
import ChangeOrCancel from './containers/reserveChange/ChangeOrCancel';
import Cancel from './containers/reserveChange/Cancel';
import CancelComplete from './containers/reserveChange/CancelComplete';
import ChangeBusinss from './containers/reserveChange/ChangeBusiness';
import ChangePlace from './containers/reserveChange/ChangePlace';
import ChangeDate from './containers/reserveChange/ChangeDate';
import ChangeTime from './containers/reserveChange/ChangeTime';
import ChangeForm from './containers/reserveChange/ChangeForm';
import ChangeConfirmation from './containers/reserveChange/ChangeConfirmation';
import ChangeComplete from './containers/reserveChange/ChangeComplete';

// リダイレクト
import Redirect from './containers/reserveChange/Redirect';
import RedirectPage from './containers/reserveChange/RedirectPage';

// 未登録市町村用ページ
import UnregisteredPage from './containers/error/UnregisteredPage';

// ページ遷移時にページのtopまでscrollするcomponent
import ScrollTop from './components/ScrollTop';

const App = function () {
  const isLoggedIn = useSelector((state) => state.login.accessToken);

  const auth = (element) => {
    if (isLoggedIn) {
      return element;
    }
    return <Login />;
  };

  const basicRoutes = (
    <>
      <Route path=":lgCd" element={<Top />} />
      <Route path="date" element={<SelectDate />} />
      <Route path="time" element={<SelectTime />} />
      <Route path="business" element={<SelectBusiness />} />
      <Route path="place" element={<SelectPlace />} />
      {/* <Route path="userinfo" element={<InputUserInfo />} /> */}
      <Route path="userinfo" element={<CustomizeReserveForm />} />
      {/* <Route path="confirmation" element={<Confirmation />} /> */}
      <Route path="confirmation" element={<CustomizeConfirmation />} />
      {/* <Route path="cmplt" element={<Complete />} /> */}
      <Route path="cmplt" element={<CustomizeComplete />} />
    </>
  );

  return (
    <BrowserRouter basename="/reserve">
      <ScrollTop />
      <Routes>
        <Route path="/" element={<BaseFrame />}>
          {basicRoutes}
        </Route>

        <Route path="syokuin" element={auth(<BaseFrame />)}>
          {basicRoutes}
        </Route>

        {/* /reserve/change */}
        <Route path="/change/cancel" element={<Cancel />} />
        <Route path="/change/cancel/cmplt" element={<CancelComplete />} />
        <Route path="/change/business" element={<ChangeBusinss />} />
        <Route path="/change/place" element={<ChangePlace />} />
        <Route path="/change/date" element={<ChangeDate />} />
        <Route path="/change/time" element={<ChangeTime />} />
        <Route path="/change/userinfo" element={<ChangeForm />} />
        <Route path="/change/confirmation" element={<ChangeConfirmation />} />
        <Route path="/change/cmplt" element={<ChangeComplete />} />
        <Route path="/change/:changeUrl" element={<ChangeOrCancel />} />

        {/* redirect */}
        <Route path="/invalid/redirect" element={<Redirect />} />
        <Route path="/invalid/redirectpage" element={<RedirectPage />} />

        {/* unregistered */}
        <Route path="/unregistered" element={<UnregisteredPage />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
